var colors = require('../colors');

module['exports'] = (function () {
  var rainbowColors = ['red', 'yellow', 'green', 'blue', 'magenta']; //RoY G BiV
  return function (letter, i, exploded) {
    if (letter === " ") {
      return letter;
    } else {
      return colors[rainbowColors[i++ % rainbowColors.length]](letter);
    }
  };
})();




/*****************
 ** WEBPACK FOOTER
 ** ./~/colors/lib/maps/rainbow.js
 ** module id = 112
 ** module chunks = 0
 **/